import { FilterSettingsFragment } from '@warebee/frontend/data-access-api-graphql';
import { DatasetExtraField, FilterPreset } from '@warebee/shared/common';
import _ from 'lodash';
import { FilterFieldConfig } from '../../common/types';
import { getExtraFieldFieldConfig } from '../../policyFilters/policyFilter.helper';

export type CustomizedFilterConfigParams = {
  filterConfigDefault: FilterFieldConfig<string>[];
  filterSettings: FilterSettingsFragment;
  extraFields: DatasetExtraField[];
};

export function getCustomizedFilterConfig(
  params: CustomizedFilterConfigParams,
): FilterFieldConfig<string>[] {
  const filterOverridesMap = _.keyBy(
    params.filterSettings?.filterConfigOverrides,
    f => f.type,
  );

  const actualityHqConfigExtra: FilterFieldConfig<string>[] = _.map(
    params.extraFields,
    f => getExtraFieldFieldConfig(f),
  );
  const actualityHqConfig = [
    ...(params.filterConfigDefault ?? []),
    ...actualityHqConfigExtra,
  ]
    .map(f => ({ ...f, ...filterOverridesMap[f.type] }))
    .filter(f => !f.disabled);

  return actualityHqConfig;
}

export type CreateDynamicFilterPresetParams = {
  id: string;
  title: string;
  column: string;
  values: any[];
};

export function createDynamicFilterPreset(
  params: CreateDynamicFilterPresetParams,
): FilterPreset<string> {
  return {
    id: params.id,
    title: params.title,
    filterUnion: {
      anyOf: [
        {
          allOf: [
            {
              type: _.camelCase(params.column),
              valueIn: _.map(params.values, v => ({ title: v.toString() })),
            },
          ],
        },
      ],
    },
  };
}
